import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from "recharts";
import { GitBranch } from "@phosphor-icons/react";

export default function TrattoLossChart({ tratti }) {
  const data = (tratti || [])
    .map((t) => ({
      id: t.id,
      nome: t.nome,
      perdita: t.perdita_lh,
      colore: t.colore || (t.perdita_lh > 1000 ? "#EF4444" : "#10B981"),
      ingresso: t.ingresso_lh,
      uscita: t.uscita_lh,
    }))
    .sort((a, b) => b.perdita - a.perdita);

  return (
    <div className="bg-[#111827] border border-slate-800 rounded-lg" data-testid="tratto-loss-chart">
      <div className="px-5 py-4 border-b border-slate-800 flex items-center gap-2">
        <GitBranch size={20} weight="duotone" className="text-[#3EB6F0]" />
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Prioritizzazione Intervento</div>
          <div className="font-heading text-lg text-white">Perdite per Tratto Condotta</div>
        </div>
      </div>
      <div className="p-4 h-[240px]">
        {data.length === 0 ? (
          <div className="h-full grid place-items-center text-xs font-mono text-slate-500">Nessun tratto configurato</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ top: 8, right: 40, left: 8, bottom: 8 }}>
              <CartesianGrid stroke="#1E293B" strokeDasharray="3 3" horizontal={false} />
              <XAxis type="number" tick={{ fill: "#64748B", fontSize: 10, fontFamily: "IBM Plex Mono" }}
                tickLine={{ stroke: "#334155" }} axisLine={{ stroke: "#334155" }}
                label={{ value: "L/h dispersi", position: "insideBottom", offset: -2, fill: "#64748B", fontSize: 10 }}
              />
              <YAxis type="category" dataKey="id" width={110}
                tick={{ fill: "#94A3B8", fontSize: 11, fontFamily: "IBM Plex Mono" }}
                tickLine={{ stroke: "#334155" }} axisLine={{ stroke: "#334155" }}
              />
              <Tooltip
                cursor={{ fill: "#1E293B33" }}
                contentStyle={{ background: "#0a0f1c", border: "1px solid #1E293B", fontSize: 11, fontFamily: "IBM Plex Mono" }}
                formatter={(v, k, item) => [`${v} L/h`, item.payload.nome]}
              />
              <Bar dataKey="perdita" radius={[0, 4, 4, 0]}>
                {data.map((d, i) => <Cell key={i} fill={d.colore} />)}
                <LabelList dataKey="perdita" position="right"
                  style={{ fill: "#94A3B8", fontSize: 10, fontFamily: "IBM Plex Mono" }}
                  formatter={(v) => `${Math.round(v)} L/h`}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
